module.exports = __webpack_public_path__ + "static/media/land-bg.c2f5048e.jpg";